import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { NbToastrService, NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-setting-menu',
  templateUrl: './setting-menu.component.html',
  styleUrls: ['./setting-menu.component.scss']
})
export class SettingMenuComponent implements OnInit {
  menu:any= [];
  pone;
  ptwo;
  ptree;
  hideLoader = true;
  hideButon;
  category:any = [];
  categoiIdm;
  categoiIdf3;
  categoiIdf2;
  categoiIdAchive;
  categoiIdf1;
  tableauMenu:any = [];
  tableauFooter3:any = [];
  tableauFooter1:any = [];
  tableauFooter2:any = [];
  tableauArchive:any = [];
  empSelected;
  main;
  p1;
  menus:any = [];
  p2
  p3;
  archives;
  @ViewChild('userRegistrationForm',{static:true}) myForm; 
  constructor(protected dialogRef: NbDialogRef<SettingMenuComponent>,private apiservice:ApiService,private router:Router,public toastr:NbToastrService) { }

  ngOnInit() {
    this.empSelected = 63;
    this.getMenu();

    this.getMenParameters();
  }

  cancel(){
    this.dialogRef.close();
  }
  getSettingMenu(){
    this.apiservice.getMenuProvider().subscribe((data:any) =>{
      this.menus.push(data) ;
      console.log( this.menus);
      for (const key in this.menus) {
        this.main = this.menus[key].main.nom;
       
       
        this.p1 = this.menus[key].footer1.nom;
        this.p2 = this.menus[key].footer2.nom;
        this.p3 = this.menus[key].footer3.nom;
        this.archives = this.menus[key].archive.nom;
       
      }
      console.log(this.p1);
      console.log(this.p2);
      console.log(this.p3);
      console.log(this.main);
      console.log(this.archives);
    })
  }

  getMenu(){
    this.apiservice.getAllMenuProvider().subscribe((data:any) =>{
      this.menu =data;
      console.log(this.menu);
     
      console.log(this.menu);
    },(err)=>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }
    })
  }

  getMenParameters(){
    this.apiservice.getMenuParametersProvider().subscribe((data:any) =>{
      
      console.log(data);

      this.categoiIdm = data.main.id;
      this.categoiIdf1 = data.footer1.id;
      this.categoiIdf2 = data.footer2.id;
      this.categoiIdf3 = data.footer3.id;
      this.categoiIdAchive = data.archive.id;

      // this.categoiIdm,this.categoiIdf1,this.categoiIdf2,this.categoiIdf3,this.categoiIdAchive
    },(err)=>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }
    })
  }

  updateMenu(){
    this.hideLoader = false;
    this.hideButon = true;
    this.apiservice.updateParametresMenuProvider(this.categoiIdm,this.categoiIdf1,this.categoiIdf2,this.categoiIdf3,this.categoiIdAchive).subscribe(data =>{
        console.log(data);
        this.toastr.success("mise à jour réussie","success"); 
        this.hideLoader = true;
        this.hideButon = false;
    },(err) =>{
      console.log(err);
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }
    })
  }


  recherche(n, data: Array<any>) {
    let i = 0;
    let trouve: Boolean = false;

    while(i < data.length && !trouve){

       if( data[i] ==n){
         trouve = true;
       }else{
         i++;
       }
       
    }

    if(trouve){
         return i;
   }else{
     return - 1;
   }
   
 }


 private remove(n, element:Array<any>){
  for( var i = 0; i <element.length; i++){ 
    if ( element[i] === n) {
      element.splice(i, 1); 
      i--;
    }
 }

 }

}
